import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { AARDataProvider } from "./context/AARDataContext";
import { AuthProvider } from "./context/AuthContext";

import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import SearchFilters from "./components/SearchFilters/SearchFilters";
import ProjectGrid from "./components/ProjectGrid/ProjectGrid";
import AARDetails from "./components/AARDetails/AARDetails";
import Dashboard from "./components/Dashboard/Dashboard";
import ActionTracker from "./components/ActionTracker/ActionTracker";
import AARManagement from "./components/AARManagement/AARManagement";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import Login from "./pages/Login/Login";
import ActivityLog from "./pages/ActivityLog/ActivityLog";
import ReviewerInbox from "./pages/ReviewerInbox/ReviewerInbox";
import UserManagement from "./pages/UserManagement/UserManagement";
import SystemSettings from "./pages/SystemSettings/SystemSettings";


// ==========================================
// HOME PAGE
// ==========================================

function Home() {

  const [searchTerm, setSearchTerm] = useState("");
  const [year, setYear] = useState("");
  const [type, setType] = useState("");
  const [area, setArea] = useState("");
  const [status, setStatus] = useState("");

  const clearFilters = () => {
    setSearchTerm("");
    setYear("");
    setType("");
    setArea("");
    setStatus("");
  };

  return (
    <>
      <Hero />

      <SearchFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}

        year={year}
        setYear={setYear}

        type={type}
        setType={setType}

        area={area}
        setArea={setArea}

        status={status}
        setStatus={setStatus}
        onClear={clearFilters}
      />

      <ProjectGrid
        searchTerm={searchTerm}
        year={year}
        type={type}
        area={area}
        status={status}
      />
    </>
  );
}


// ==========================================
// MAIN APP
// ==========================================

function App() {

  return (
    <AuthProvider>

      <AARDataProvider>

      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >

        {/* GLOBAL NAVBAR */}
        <Navbar />

        <Routes>

          {/* =================================
              AAR LIBRARY
          ================================== */}

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />


          {/* =================================
              AAR DETAILS
          ================================== */}

          <Route
            path="/aar/:id"
            element={
              <ProtectedRoute>
                <AARDetails />
              </ProtectedRoute>
            }
          />


          {/* =================================
              DASHBOARD
          ================================== */}

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={["admin", "reviewer", "viewer"]}>
                <Dashboard />
              </ProtectedRoute>
            }
          />


          {/* =================================
              ACTION TRACKER
          ================================== */}

          <Route
            path="/action-tracker"
            element={
              <ProtectedRoute allowedRoles={["admin", "reviewer", "viewer"]}>
                <ActionTracker />
              </ProtectedRoute>
            }
          />


          {/* =================================
              AAR MANAGEMENT
          ================================== */}

          <Route
            path="/manage-aar"
            element={
              <ProtectedRoute allowedRoles={["admin", "reviewer", "viewer"]}>
                <AARManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/reviewer-inbox"
            element={
              <ProtectedRoute allowedRoles={["admin", "reviewer"]}>
                <ReviewerInbox />
              </ProtectedRoute>
            }
          />

          <Route
            path="/activity"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <ActivityLog />
              </ProtectedRoute>
            }
          />

          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <UserManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <SystemSettings />
              </ProtectedRoute>
            }
          />

          <Route
            path="/login"
            element={<Login />}
          />


          {/* =================================
              FALLBACK
          ================================== */}

          <Route
            path="*"
            element={<Home />}
          />

        </Routes>

      </BrowserRouter>

      </AARDataProvider>

    </AuthProvider>
  );
}


export default App;